import Repository from "../Repository";

const resource = "/bo/manpowers";

export default {
  /**
   * Get all manpowers
   */
  get() {
    return Repository.get(`${resource}`);
  },

  /**
   * Create a manpower
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  },

  /**
   * Get a manpower
   */
  getManpower(manpowerId) {
    return Repository.get(`${resource}/${manpowerId}`);
  },

  /**
   * Update a manpower
   */
  updateManpower(manpowerId, payload) {
    return Repository.put(`${resource}/${manpowerId}`, payload);
  },

  /**
   * Delete a manpower
   */
  deleteManpower(manpowerId) {
    return Repository.delete(`${resource}/${manpowerId}`);
  }
};
